/**
 * Push first (docs/superpowers/specs/2026-11-01-push-first-design.md § 3): while a site's page is open
 * — in a browser or the app, any of its brand pages — the server is told, on opening (a tap on a push
 * included, also for the page already shown) and on coming back to it; that person's open outages
 * there then count as seen, so WhatsApp and RCS are not sent. Errors are ignored.
 */
import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { sitesApi } from '../../lib/api'

// a site's id is a UUID: /sites/teltonika/register, /sites/starlink and the like are no site's page
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const siteOf = (pathname: string) => {
  const id = (matchPath('/sites/:siteId/*', pathname) ?? matchPath('/sites/:siteId', pathname))?.params.siteId
  return id && UUID.test(id) ? id : null
}

export default function SiteSeen() {
  const location = useLocation()
  const siteId = siteOf(location.pathname)
  useEffect(() => {
    if (!siteId) return
    const tell = () => { void sitesApi.seen(siteId).catch(() => undefined) }
    tell()
    const back = () => { if (document.visibilityState === 'visible') tell() }
    document.addEventListener('visibilitychange', back)
    return () => document.removeEventListener('visibilitychange', back)
    // location.key: a new visit of the same page (a push tapped while it shows) tells again
  }, [siteId, location.key])
  return null
}
